/**
 * @generated SignedSource<<5cf6e25f8d59bc83d5b810f8d3e81e14>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type EmbeddedColorTypes = "CMYK" | "NONE" | "PANTONE";
export type ImageInsertScalingType = "AUTOFIT_SCALE_TO_COVER" | "AUTOFIT_SCALE_TO_FIT" | "SCALE_DOWN";
export type OutputMirrorPrintFiles = "BOTH" | "MIRROR_HORIZONTALLY" | "MIRROR_VERTICALLY" | "NONE";
export type ProductConfigurationStatus = "COMPLETE" | "NONE" | "PARTIAL";
export type ProductMirrorTypes = "COLORED" | "MIRRORED" | "NONE";
export type ProductProvider = "CASA_DE_LAS_CARCASAS" | "CUSTOM_CAT" | "FAVORITE_GIFT" | "HP" | "INVITION" | "PRINTFUL" | "PRINTFUL_DIRECT" | "UNDEFINED" | "VERSORI" | "ZAKEKE";
export type VectorizeOptionTypeEnum = "NONE" | "RASTER";
export type ModelUpdateOrCreateInput = {
  attributeGroups?: NullableValueInputOfListOfAttributeGroupInput | null;
  attributeSteps?: NullableValueInputOfListOfAttributeStepInput | null;
  attributes?: NullableValueInputOfListOfAttributeInput | null;
  cameraSideMappings?: NullableValueInputOfListOfCameraSideMappingInput | null;
  code?: ValueInputOfStringInput | null;
  colors?: NullableValueInputOfListOfModelColorCreateInput | null;
  environment?: ValueInputOfInt32Input | null;
  id?: string | null;
  largeImageUrl?: ValueInputOfStringInput | null;
  name?: ValueInputOfStringInput | null;
  options?: NullableValueInputOfListOfModelOptionInput | null;
  preview3D?: NullableValueInputOfPreview3DInput | null;
  pricingModelID?: ValueInputOfInt32Input | null;
  providerCode?: ValueInputOfStringInput | null;
  salesChannelID?: NullableValueInputOfStringInput | null;
  sceneConfig?: NullableValueInputOfModelSceneConfigInput | null;
  scenes?: NullableValueInputOfListOfModelSceneInput | null;
  smallImageUrl?: ValueInputOfStringInput | null;
  statusID?: ValueInputOfInt32Input | null;
};
export type ValueInputOfInt32Input = {
  value: number;
};
export type ValueInputOfStringInput = {
  value?: string | null;
};
export type NullableValueInputOfListOfModelColorCreateInput = {
  value?: ReadonlyArray<ModelColorCreateInput | null> | null;
};
export type ModelColorCreateInput = {
  code: string;
  colorGuid: any;
  colorId?: number | null;
  colorProviderCode?: string | null;
  name?: string | null;
  position: number;
  sides?: ReadonlyArray<ModelSideCreateInput | null> | null;
};
export type ModelSideCreateInput = {
  areas: ReadonlyArray<ModelAreaCreateInput>;
  cameraLocationID?: any | null;
  canRotate: boolean;
  code: string;
  imageUrl: string;
  mandatory: boolean;
  name: string;
  ppcm: number;
  sideGuid: any;
  sideId?: number | null;
  sortOrder: number;
  tempImageFileKey: string;
};
export type ModelAreaCreateInput = {
  areaId?: number | null;
  boundsHeight: number;
  boundsWidth: number;
  boundsX: number;
  boundsY: number;
  clipOut: boolean;
  guid: string;
  layers: ReadonlyArray<ModelAreaLayerCreateInput>;
  name: string;
  path: string;
  pathSVG: string;
  templateFile?: ModelAreaTemplateFileCreateInput | null;
};
export type ModelAreaLayerCreateInput = {
  description: string;
  displayName: string;
  displayOrder: number;
  id?: string | null;
  isClipMask: boolean;
  isOutputClipped: boolean;
  isVisibleInCanvas: boolean;
  isVisibleInCart: boolean;
  isVisibleInOutput: boolean;
  json: string;
  name: string;
  showIn3DPreview: boolean;
  showLabel: boolean;
  svg: string;
};
export type ModelAreaTemplateFileCreateInput = {
  documentHeight: number;
  documentWidth: number;
  fileID?: string | null;
  fileObjectID?: number | null;
};
export type NullableValueInputOfListOfModelOptionInput = {
  value?: ReadonlyArray<ModelOptionInput | null> | null;
};
export type ModelOptionInput = {
  colorGuid: any;
  optionId?: number | null;
  optionsData: ModelOptionsDataInput;
  sideGuid?: any | null;
};
export type ModelOptionsDataInput = {
  backgroundColor?: string | null;
  backgroundImageFileObjectID?: number | null;
  backgroundImageTempUrl?: string | null;
  backgroundImageThumbnailFileObjectID?: number | null;
  backgroundImageThumbnailUrl?: string | null;
  backgroundImageUrl?: string | null;
  backgroundPresetID?: number | null;
  backgroundType?: number | null;
  depth?: number | null;
  edgesColor?: string | null;
  includeBorderInPrintFiles: boolean;
  is3DAutoGenEnabled: boolean;
  isResizable: boolean;
  isSplitOutput: boolean;
  keepAspectRatio: boolean;
  lockHeight: boolean;
  lockWidth: boolean;
  maxArea?: number | null;
  maxHeight?: number | null;
  maxSizeForSide?: number | null;
  maxWidth?: number | null;
  minArea?: number | null;
  minHeight?: number | null;
  minSplitHeight?: number | null;
  minSplitWidth?: number | null;
  minWidth?: number | null;
  mirrorType: ProductMirrorTypes;
  presets: ReadonlyArray<ModelOptionDataPresetDataInput>;
  shape: number;
  showHeightSize: boolean;
  showSplitGrid: boolean;
  showWidthSize: boolean;
  startHeight?: number | null;
  startSplitColumns?: number | null;
  startSplitRows?: number | null;
  startWidth?: number | null;
  stepHeight?: number | null;
  stepWidth?: number | null;
};
export type ModelOptionDataPresetDataInput = {
  height: number;
  name?: string | null;
  width: number;
};
export type NullableValueInputOfListOfModelSceneInput = {
  value?: ReadonlyArray<ModelSceneInput | null> | null;
};
export type ModelSceneInput = {
  isDefault: boolean;
  meshDesignEffects: ReadonlyArray<ModelSceneMeshDesignEffectInput>;
  meshSides: ReadonlyArray<ModelSceneMeshSideInput>;
  sceneId?: any | null;
};
export type ModelSceneMeshSideInput = {
  colorID?: number | null;
  config?: MeshDesignConfigInput | null;
  isNormalmapEnabled: boolean;
  key?: string | null;
  materialID?: any | null;
  materialTexture?: string | null;
  matrix?: string | null;
  meshID: any;
  percHeight: number;
  percWidth: number;
  sideID: number;
  subMeshID: number;
  transform?: TransformInput | null;
  uvChannel: number;
};
export type TransformInput = {
  positionX: number;
  positionY: number;
  rotation: number;
  scalingX: number;
  scalingY: number;
};
export type MeshDesignConfigInput = {
  diffuse?: DiffuseConfigInput | null;
  general?: MeshDesignGeneralConfigInput | null;
  innerShadow?: InnerShadowConfigInput | null;
  normalmap?: NormalmapConfigInput | null;
  opacity?: OpacityConfigInput | null;
  outerShadow?: OuterShadowConfigInput | null;
};
export type MeshDesignGeneralConfigInput = {
  desktopTextureResolutionHeight?: number | null;
  desktopTextureResolutionWidth?: number | null;
  mobileTextureResolutionHeight?: number | null;
  mobileTextureResolutionWidth?: number | null;
  showDesign: boolean;
};
export type DiffuseConfigInput = {
  blendMode?: string | null;
  enabled: boolean;
  level: number;
};
export type OpacityConfigInput = {
  enabled: boolean;
};
export type NormalmapConfigInput = {
  bevel: boolean;
  bias: number;
  enabled: boolean;
  intensity: number;
  invertG: boolean;
  invertR: boolean;
  postBlur: number;
  postBlurEnabled: boolean;
  preBlur: number;
  preBlurEnabled: boolean;
  showDesign: boolean;
  showOnDesign: boolean;
  showOnMesh: boolean;
};
export type OuterShadowConfigInput = {
  angle: number;
  color?: string | null;
  distance: number;
  enabled: boolean;
  size: number;
};
export type InnerShadowConfigInput = {
  angle: number;
  color?: string | null;
  distance: number;
  enabled: boolean;
  size: number;
};
export type ModelSceneMeshDesignEffectInput = {
  config?: MeshDesignConfigInput | null;
  effectID?: any | null;
  isDefault: boolean;
  materialID?: any | null;
  meshID: any;
  name?: string | null;
  subMeshID: number;
};
export type NullableValueInputOfListOfAttributeInput = {
  value?: ReadonlyArray<AttributeInput | null> | null;
};
export type AttributeInput = {
  attributeCode?: string | null;
  attributeGuid: any;
  attributeId?: number | null;
  attributeTypeID: number;
  constraintExpression?: AttributeExpressionInput | null;
  defaultValue?: string | null;
  description?: string | null;
  displayOrder: number;
  groupGuid: any;
  groupID: number;
  hideOptionsLabel: boolean;
  meshSelector?: string | null;
  name?: string | null;
  optionPreviewShapeID: number;
  options: ReadonlyArray<AttributeOptionInput>;
  postActions: ReadonlyArray<AttributeSceneActionInput>;
  preActions: ReadonlyArray<AttributeSceneActionInput>;
  pricings: ReadonlyArray<AttributePricingInput>;
  sceneCameraLocationID?: any | null;
  stepGuid: any;
  stepID: number;
  valueActions: ReadonlyArray<AttributeSceneActionInput>;
};
export type AttributeOptionInput = {
  actions: ReadonlyArray<AttributeSceneActionInput>;
  constraintExpression?: AttributeExpressionInput | null;
  description?: string | null;
  displayOrder: number;
  extensionFields: ReadonlyArray<AttributeOptionExtensionFieldInput>;
  imageFileObjectID: number;
  imageUrl?: string | null;
  isDefault: boolean;
  name?: string | null;
  optionCode?: string | null;
  optionGuid: any;
  optionId?: number | null;
  tempImageFileKey?: string | null;
  tempImageFileObjectID: number;
};
export type AttributeExpressionInput = {
  expressions: ReadonlyArray<AttributeExpressionInput>;
  op?: string | null;
  propositions: ReadonlyArray<AttributePropositionInput>;
};
export type AttributePropositionInput = {
  attributeGuid?: any | null;
  op?: string | null;
  value?: string | null;
};
export type AttributeSceneActionInput = {
  actionGuid: any;
  actionId?: number | null;
  actionTypeID: number;
  deviceTypes: number;
  execOrder: number;
  name?: string | null;
  propertyName?: string | null;
  sceneElementTypeID: number;
  selector?: string | null;
  value?: string | null;
};
export type AttributeOptionExtensionFieldInput = {
  dataTypeID: number;
  extensionFieldID?: number | null;
  formatString?: string | null;
  label?: string | null;
  name?: string | null;
  operationTypeID: number;
  value?: string | null;
};
export type AttributePricingInput = {
  attributePricingID?: number | null;
  constraintExpression?: AttributeExpressionInput | null;
  name?: string | null;
  price: number;
  pricingID: number;
  selectedOptionGuid?: any | null;
  selectedOptionID?: number | null;
  selectedValue?: string | null;
};
export type NullableValueInputOfListOfAttributeGroupInput = {
  value?: ReadonlyArray<AttributeGroupInput | null> | null;
};
export type AttributeGroupInput = {
  attributesAlwaysOpened: boolean;
  direction: number;
  displayOrder: number;
  groupGuid: any;
  groupID: number;
  imageUrl?: string | null;
  meshSelector?: string | null;
  name?: string | null;
  sceneCameraLocationID?: any | null;
  tempImageFileKey?: string | null;
  tempImageUrl?: string | null;
};
export type NullableValueInputOfListOfAttributeStepInput = {
  value?: ReadonlyArray<AttributeStepInput | null> | null;
};
export type AttributeStepInput = {
  cameraLocationID?: any | null;
  displayOrder: number;
  groupGuid: any;
  groupID: number;
  name?: string | null;
  stepGuid: any;
  stepID: number;
};
export type NullableValueInputOfPreview3DInput = {
  value?: Preview3DInput | null;
};
export type Preview3DInput = {
  variantsAttributeOptions?: VariantsAttributeOptionsInput | null;
};
export type VariantsAttributeOptionsInput = {
  attributeGuid: any;
  variableMaterials?: ReadonlyArray<VariableMaterialInput | null> | null;
  variantOptions?: ReadonlyArray<VariantOptionInput | null> | null;
};
export type VariableMaterialInput = {
  materialID?: string | null;
  meshes?: ReadonlyArray<string | null> | null;
};
export type VariantOptionInput = {
  materials?: ReadonlyArray<VariantOptionMaterialInput | null> | null;
  meshes?: ReadonlyArray<string | null> | null;
  optionGuid: any;
  variantID?: string | null;
};
export type VariantOptionMaterialInput = {
  actions?: ReadonlyArray<VariantOptionMaterialActionInput | null> | null;
  optionMaterialID?: string | null;
  variableMaterialID?: string | null;
};
export type VariantOptionMaterialActionInput = {
  actionGuid: any;
  meshID?: string | null;
};
export type NullableValueInputOfModelSceneConfigInput = {
  value?: ModelSceneConfigInput | null;
};
export type ModelSceneConfigInput = {
  general?: ModelSceneGeneralConfigInput | null;
};
export type ModelSceneGeneralConfigInput = {
  arAnchor?: string | null;
  arEnabled?: boolean | null;
};
export type NullableValueInputOfStringInput = {
  value?: string | null;
};
export type NullableValueInputOfListOfCameraSideMappingInput = {
  value?: ReadonlyArray<CameraSideMappingInput | null> | null;
};
export type CameraSideMappingInput = {
  cameraLocationID?: any | null;
  colorID: number;
  sideID: number;
};
export type previewUpdateMutation$variables = {
  compressedInput?: string | null;
  input?: ModelUpdateOrCreateInput | null;
};
export type previewUpdateMutation$data = {
  readonly createOrUpdateModelV2: {
    readonly model: {
      readonly additionalCodes: ReadonlyArray<{
        readonly code: string;
        readonly merchantProductName: string;
        readonly salesChannel: {
          readonly ecommerceSettings: {
            readonly ecommerceName: ECommerce;
            readonly remoteUrl: string | null;
          } | null;
        };
        readonly salesChannelID: string;
      }>;
      readonly code: string;
      readonly colors: ReadonlyArray<{
        readonly code: string | null;
        readonly colorID: number;
        readonly colorProviderCode: string | null;
        readonly name: string;
        readonly position: number;
        readonly sides: ReadonlyArray<{
          readonly areas: ReadonlyArray<{
            readonly areaID: number;
            readonly boundsHeight: number;
            readonly boundsWidth: number;
            readonly boundsX: number;
            readonly boundsY: number;
            readonly clipOut: boolean;
            readonly guid: string;
            readonly layers: ReadonlyArray<{
              readonly description: string;
              readonly displayName: string;
              readonly displayOrder: number;
              readonly isClipMask: boolean;
              readonly isOutputClipped: boolean;
              readonly isVisibleInCanvas: boolean;
              readonly isVisibleInCart: boolean;
              readonly isVisibleInOutput: boolean;
              readonly json: string;
              readonly layerID: any;
              readonly name: string;
              readonly showIn3DPreview: boolean;
              readonly showLabel: boolean;
              readonly svg: string;
            }>;
            readonly name: string;
            readonly path: string;
            readonly pathSVG: string;
            readonly templateFile: {
              readonly documentHeight: number;
              readonly documentWidth: number;
              readonly fileObjectID: number;
            } | null;
          }>;
          readonly cameraLocationID: any | null;
          readonly canRotate: boolean | null;
          readonly code: string;
          readonly imageUrl: string;
          readonly mandatory: boolean;
          readonly name: string;
          readonly ppcm: number;
          readonly sideID: number;
          readonly sortOrder: number | null;
        }>;
      }>;
      readonly configurationStatus: ProductConfigurationStatus;
      readonly environment: number;
      readonly id: string;
      readonly largeImageUrl: string | null;
      readonly modelColorMappings: ReadonlyArray<{
        readonly colorID: number;
        readonly merchantCode: string;
        readonly salesChannelID: string;
      }>;
      readonly modelID: number;
      readonly name: string;
      readonly options: ReadonlyArray<{
        readonly colorID: number;
        readonly optionID: number;
        readonly optionsData: {
          readonly backgroundColor: string | null;
          readonly backgroundImageFileObjectID: number | null;
          readonly backgroundImageTempUrl: string | null;
          readonly backgroundImageThumbnailFileObjectID: number | null;
          readonly backgroundImageThumbnailUrl: string | null;
          readonly backgroundImageUrl: string | null;
          readonly backgroundPresetID: number | null;
          readonly backgroundType: number | null;
          readonly depth: number | null;
          readonly edgesColor: string | null;
          readonly includeBorderInPrintFiles: boolean;
          readonly is3DAutoGenEnabled: boolean;
          readonly isResizable: boolean;
          readonly isSplitOutput: boolean;
          readonly keepAspectRatio: boolean;
          readonly lockHeight: boolean;
          readonly lockWidth: boolean;
          readonly maxArea: number | null;
          readonly maxHeight: number | null;
          readonly maxSizeForSide: number | null;
          readonly maxWidth: number | null;
          readonly minArea: number | null;
          readonly minHeight: number | null;
          readonly minSplitHeight: number | null;
          readonly minSplitWidth: number | null;
          readonly minWidth: number | null;
          readonly mirrorType: ProductMirrorTypes;
          readonly presets: ReadonlyArray<{
            readonly height: number;
            readonly name: string | null;
            readonly width: number;
          }>;
          readonly shape: number;
          readonly showHeightSize: boolean;
          readonly showSplitGrid: boolean;
          readonly showWidthSize: boolean;
          readonly startHeight: number | null;
          readonly startSplitColumns: number | null;
          readonly startSplitRows: number | null;
          readonly startWidth: number | null;
          readonly stepHeight: number | null;
          readonly stepWidth: number | null;
        };
        readonly sideID: number | null;
      }>;
      readonly pricingModelID: number;
      readonly printTypes: ReadonlyArray<{
        readonly canAddText: boolean | null;
        readonly canChangeSvgColors: boolean | null;
        readonly canIgnoreDPIWarning: boolean | null;
        readonly canUseImageFilters: boolean | null;
        readonly canUseTextArt: boolean | null;
        readonly defaultFontFamilyID: number | null;
        readonly disableImageColors: boolean | null;
        readonly disableSellerImages: boolean | null;
        readonly disableTextColors: boolean | null;
        readonly disableUserImages: boolean | null;
        readonly dpi: number | null;
        readonly fonts: ReadonlyArray<{
          readonly fontFamilyID: number;
          readonly fontFamilyName: string;
        }>;
        readonly imageColors: ReadonlyArray<{
          readonly colorCode: string;
          readonly isDefault: boolean;
        } | null> | null;
        readonly imageEditingToolSettingsToExclude: string | null;
        readonly name: string;
        readonly outputTypeID: number | null;
        readonly patID: number;
        readonly printTypeID: number;
        readonly printTypeRestrictions: {
          readonly allowAdaptText: boolean | null;
          readonly allowBold: boolean | null;
          readonly allowBottomVerticalAlignment: boolean | null;
          readonly allowCenterAlign: boolean | null;
          readonly allowChangeFontSize: boolean | null;
          readonly allowGradientTextColors: boolean;
          readonly allowImageGalleryTextColors: boolean;
          readonly allowImageResizeCliparts: boolean | null;
          readonly allowImageResizeUpload: boolean | null;
          readonly allowImageUploadTextColors: boolean;
          readonly allowItalic: boolean | null;
          readonly allowJustifyAlign: boolean | null;
          readonly allowLeftAlign: boolean | null;
          readonly allowLetterSpacing: boolean | null;
          readonly allowLineSpacing: boolean | null;
          readonly allowMiddleVerticalAlignment: boolean | null;
          readonly allowRightAlign: boolean | null;
          readonly allowShadows: boolean | null;
          readonly allowTextStroke: boolean | null;
          readonly allowTopVerticalAlignment: boolean | null;
          readonly canAddText: boolean | null;
          readonly canChangeSvgColors: boolean | null;
          readonly canIgnoreDPIWarning: boolean | null;
          readonly canPrintShadows: boolean;
          readonly canStretchImages: boolean | null;
          readonly canStretchTexts: boolean | null;
          readonly canUseImageFilters: boolean | null;
          readonly canUseTextArt: boolean | null;
          readonly convertAiToSvg: boolean | null;
          readonly convertEpsToSvg: boolean | null;
          readonly convertPdfToSvg: boolean | null;
          readonly createVectorizePreview: boolean;
          readonly curvedText: boolean | null;
          readonly defaultColor: string | null;
          readonly defaultFontFamilyID: number | null;
          readonly defaultFontSize: number | null;
          readonly defaultShadowAngle: number | null;
          readonly defaultShadowBlur: number | null;
          readonly defaultShadowColor: string | null;
          readonly defaultShadowDistance: number | null;
          readonly disableImageColors: boolean | null;
          readonly disableImageRotateCliparts: boolean | null;
          readonly disableImageRotateUpload: boolean | null;
          readonly disableSellerImages: boolean | null;
          readonly disableTextColors: boolean | null;
          readonly disableUserImages: boolean | null;
          readonly embeddedColorType: EmbeddedColorTypes;
          readonly embeddedPdf: boolean;
          readonly embeddedUseForRasterAlso: boolean;
          readonly enableVectorize: boolean;
          readonly fixedFontSize: number | null;
          readonly fontSizeList: ReadonlyArray<number> | null;
          readonly fonts: ReadonlyArray<{
            readonly fontFamilyID: number;
            readonly fontFamilyName: string;
          }> | null;
          readonly imageColors: ReadonlyArray<{
            readonly colorCode: string;
            readonly isDefault: boolean;
          }> | null;
          readonly imageEditingToolSettingsToExclude: string | null;
          readonly imageInsertScalingCliparts: ImageInsertScalingType | null;
          readonly imageInsertScalingUpload: ImageInsertScalingType | null;
          readonly isLargeFileEnabled: boolean;
          readonly maxFontSize: number | null;
          readonly maxHeightImageResizeCliparts: number | null;
          readonly maxHeightImageResizeUpload: number | null;
          readonly maxLetterSpacing: number | null;
          readonly maxLineSpacing: number | null;
          readonly maxNrImages: number | null;
          readonly maxNrTextElements: number | null;
          readonly maxShadowAngle: number | null;
          readonly maxShadowBlur: number | null;
          readonly maxShadowDistance: number | null;
          readonly maxTextStrokeWidth: number | null;
          readonly maxWidthImageResizeCliparts: number | null;
          readonly maxWidthImageResizeUpload: number | null;
          readonly minFontSize: number | null;
          readonly minHeightImageResizeCliparts: number | null;
          readonly minHeightImageResizeUpload: number | null;
          readonly minLetterSpacing: number | null;
          readonly minLineSpacing: number | null;
          readonly minShadowAngle: number | null;
          readonly minShadowBlur: number | null;
          readonly minShadowDistance: number | null;
          readonly minTextStrokeWidth: number | null;
          readonly minWidthImageResizeCliparts: number | null;
          readonly minWidthImageResizeUpload: number | null;
          readonly outputMirror: OutputMirrorPrintFiles | null;
          readonly shadowColors: ReadonlyArray<{
            readonly colorCode: string;
            readonly isDefault: boolean;
          }> | null;
          readonly showImageProvider: boolean | null;
          readonly showVectorizeModal: boolean;
          readonly textBox: boolean | null;
          readonly textColors: ReadonlyArray<{
            readonly colorCode: string;
            readonly isDefault: boolean;
          }> | null;
          readonly uploadRestrictions: {
            readonly isAiAllowed: boolean | null;
            readonly isEpsAllowed: boolean | null;
            readonly isFacebookAllowed: boolean | null;
            readonly isInstagramAllowed: boolean | null;
            readonly isJpgAllowed: boolean | null;
            readonly isPdfAllowed: boolean | null;
            readonly isPdfWithRasterAllowed: boolean | null;
            readonly isPngAllowed: boolean | null;
            readonly isSvgAllowed: boolean | null;
            readonly isUserImageAllowed: boolean | null;
            readonly resizeLargePdf: boolean | null;
          } | null;
          readonly uppercase: boolean | null;
          readonly useCustomFonts: boolean | null;
          readonly useImagesFixedSize: boolean | null;
          readonly vectorizeOption: VectorizeOptionTypeEnum;
        } | null;
        readonly printTypeRestrictionsID: number | null;
        readonly showImageProvider: boolean | null;
        readonly textColors: ReadonlyArray<{
          readonly colorCode: string;
          readonly isDefault: boolean;
        } | null> | null;
        readonly uploadRestrictions: {
          readonly isEpsAllowed: boolean | null;
          readonly isFacebookAllowed: boolean | null;
          readonly isInstagramAllowed: boolean | null;
          readonly isJpgAllowed: boolean | null;
          readonly isPdfAllowed: boolean | null;
          readonly isPdfWithRasterAllowed: boolean | null;
          readonly isPngAllowed: boolean | null;
          readonly isSvgAllowed: boolean | null;
          readonly isUserImageAllowed: boolean | null;
        } | null;
        readonly useCustomFonts: boolean | null;
        readonly useImagesFixedSize: boolean | null;
      }>;
      readonly provider: ProductProvider;
      readonly providerCode: string | null;
      readonly salesChannel: {
        readonly ecommerceSettings: {
          readonly ecommerceName: ECommerce;
        } | null;
      };
      readonly salesChannelID: string;
      readonly sceneConfig: {
        readonly general: {
          readonly arAnchor: string | null;
          readonly arEnabled: boolean | null;
        } | null;
      } | null;
      readonly smallImageUrl: string;
      readonly sourceProductTemplateID: number | null;
      readonly statusID: number;
    } | null;
  };
};
export type previewUpdateMutation = {
  response: previewUpdateMutation$data;
  variables: previewUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "compressedInput"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "compressedInput",
    "variableName": "compressedInput"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modelID",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusID",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "configurationStatus",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "providerCode",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesChannelID",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sourceProductTemplateID",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "merchantProductName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remoteUrl",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "colorID",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "ModelColorMapping",
  "kind": "LinkedField",
  "name": "modelColorMappings",
  "plural": true,
  "selections": [
    (v15/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "merchantCode",
      "storageKey": null
    },
    (v10/*:: as any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pricingModelID",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "largeImageUrl",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "smallImageUrl",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "environment",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sideID",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "ModelOption",
  "kind": "LinkedField",
  "name": "options",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "optionID",
      "storageKey": null
    },
    (v15/*:: as any*/),
    (v22/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ModelOptionsData",
      "kind": "LinkedField",
      "name": "optionsData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isResizable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "is3DAutoGenEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSplitOutput",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "stepWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxSizeForSide",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "stepHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minArea",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxArea",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "depth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "keepAspectRatio",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showWidthSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showHeightSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showSplitGrid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mirrorType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "edgesColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minSplitWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minSplitHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startSplitColumns",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startSplitRows",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "includeBorderInPrintFiles",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "backgroundType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "backgroundColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "backgroundPresetID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "backgroundImageTempUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "backgroundImageFileObjectID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "backgroundImageThumbnailFileObjectID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "backgroundImageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "backgroundImageThumbnailUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ModelOptionDataPresetData",
          "kind": "LinkedField",
          "name": "presets",
          "plural": true,
          "selections": [
            (v7/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shape",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "SceneConfig",
  "kind": "LinkedField",
  "name": "sceneConfig",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SceneGeneralConfig",
      "kind": "LinkedField",
      "name": "general",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "arEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "arAnchor",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableTextColors",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableImageColors",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableSellerImages",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableUserImages",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useImagesFixedSize",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canAddText",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useCustomFonts",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canChangeSvgColors",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canUseImageFilters",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canIgnoreDPIWarning",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageEditingToolSettingsToExclude",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showImageProvider",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canUseTextArt",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultFontFamilyID",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "PrintTypeFont",
  "kind": "LinkedField",
  "name": "fonts",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fontFamilyID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fontFamilyName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v40 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "colorCode",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isDefault",
    "storageKey": null
  }
],
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "RestrictionColor",
  "kind": "LinkedField",
  "name": "textColors",
  "plural": true,
  "selections": (v40/*:: as any*/),
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "RestrictionColor",
  "kind": "LinkedField",
  "name": "imageColors",
  "plural": true,
  "selections": (v40/*:: as any*/),
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isUserImageAllowed",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isJpgAllowed",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPngAllowed",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSvgAllowed",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPdfAllowed",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPdfWithRasterAllowed",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEpsAllowed",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFacebookAllowed",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInstagramAllowed",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "ModelPrintType",
  "kind": "LinkedField",
  "name": "printTypes",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "printTypeID",
      "storageKey": null
    },
    (v7/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dpi",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "outputTypeID",
      "storageKey": null
    },
    (v25/*:: as any*/),
    (v26/*:: as any*/),
    (v27/*:: as any*/),
    (v28/*:: as any*/),
    (v29/*:: as any*/),
    (v30/*:: as any*/),
    (v31/*:: as any*/),
    (v32/*:: as any*/),
    (v33/*:: as any*/),
    (v34/*:: as any*/),
    (v35/*:: as any*/),
    (v36/*:: as any*/),
    (v37/*:: as any*/),
    (v38/*:: as any*/),
    (v39/*:: as any*/),
    (v41/*:: as any*/),
    (v42/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "UploadRestriction",
      "kind": "LinkedField",
      "name": "uploadRestrictions",
      "plural": false,
      "selections": [
        (v43/*:: as any*/),
        (v44/*:: as any*/),
        (v45/*:: as any*/),
        (v46/*:: as any*/),
        (v47/*:: as any*/),
        (v48/*:: as any*/),
        (v49/*:: as any*/),
        (v50/*:: as any*/),
        (v51/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "printTypeRestrictionsID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PartPrintTypeRestriction",
      "kind": "LinkedField",
      "name": "printTypeRestrictions",
      "plural": false,
      "selections": [
        (v25/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowGradientTextColors",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowImageUploadTextColors",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowImageGalleryTextColors",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enableVectorize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showVectorizeModal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vectorizeOption",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createVectorizePreview",
          "storageKey": null
        },
        (v26/*:: as any*/),
        (v27/*:: as any*/),
        (v28/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "embeddedColorType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "embeddedUseForRasterAlso",
          "storageKey": null
        },
        (v29/*:: as any*/),
        (v30/*:: as any*/),
        (v31/*:: as any*/),
        (v32/*:: as any*/),
        (v33/*:: as any*/),
        (v34/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canStretchImages",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canStretchTexts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowImageResizeUpload",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minWidthImageResizeUpload",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxWidthImageResizeUpload",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minHeightImageResizeUpload",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxHeightImageResizeUpload",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowImageResizeCliparts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minWidthImageResizeCliparts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxWidthImageResizeCliparts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minHeightImageResizeCliparts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxHeightImageResizeCliparts",
          "storageKey": null
        },
        (v35/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageInsertScalingUpload",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageInsertScalingCliparts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "disableImageRotateUpload",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "disableImageRotateCliparts",
          "storageKey": null
        },
        (v36/*:: as any*/),
        (v37/*:: as any*/),
        (v38/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "convertPdfToSvg",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "convertAiToSvg",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "convertEpsToSvg",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "curvedText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowBold",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowItalic",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uppercase",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxNrTextElements",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowLeftAlign",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowCenterAlign",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowJustifyAlign",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowRightAlign",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxNrImages",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "textBox",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowLetterSpacing",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minLetterSpacing",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxLetterSpacing",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowLineSpacing",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minLineSpacing",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxLineSpacing",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowAdaptText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowChangeFontSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minFontSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxFontSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fixedFontSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fontSizeList",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultFontSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowTopVerticalAlignment",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowMiddleVerticalAlignment",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowBottomVerticalAlignment",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowShadows",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canPrintShadows",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultShadowColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultShadowBlur",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultShadowDistance",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultShadowAngle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minShadowBlur",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxShadowBlur",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minShadowDistance",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxShadowDistance",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minShadowAngle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxShadowAngle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "outputMirror",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isLargeFileEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowTextStroke",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minTextStrokeWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxTextStrokeWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "embeddedPdf",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RestrictionColor",
          "kind": "LinkedField",
          "name": "shadowColors",
          "plural": true,
          "selections": (v40/*:: as any*/),
          "storageKey": null
        },
        (v39/*:: as any*/),
        (v41/*:: as any*/),
        (v42/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "UploadRestriction",
          "kind": "LinkedField",
          "name": "uploadRestrictions",
          "plural": false,
          "selections": [
            (v43/*:: as any*/),
            (v44/*:: as any*/),
            (v45/*:: as any*/),
            (v46/*:: as any*/),
            (v47/*:: as any*/),
            (v48/*:: as any*/),
            (v49/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAiAllowed",
              "storageKey": null
            },
            (v50/*:: as any*/),
            (v51/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "resizeLargePdf",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "Color",
  "kind": "LinkedField",
  "name": "colors",
  "plural": true,
  "selections": [
    (v15/*:: as any*/),
    (v7/*:: as any*/),
    (v8/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "colorProviderCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "position",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Side",
      "kind": "LinkedField",
      "name": "sides",
      "plural": true,
      "selections": [
        (v22/*:: as any*/),
        (v7/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ppcm",
          "storageKey": null
        },
        (v8/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sortOrder",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mandatory",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canRotate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cameraLocationID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Area",
          "kind": "LinkedField",
          "name": "areas",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "areaID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "boundsWidth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "boundsHeight",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "boundsX",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "boundsY",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pathSVG",
              "storageKey": null
            },
            (v7/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "clipOut",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "guid",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AreaLayer",
              "kind": "LinkedField",
              "name": "layers",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "layerID",
                  "storageKey": null
                },
                (v7/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isVisibleInCanvas",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isVisibleInCart",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isVisibleInOutput",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "showLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isClipMask",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isOutputClipped",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "showIn3DPreview",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayOrder",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "svg",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "json",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AreaTemplateFile",
              "kind": "LinkedField",
              "name": "templateFile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fileObjectID",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "documentWidth",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "documentHeight",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "previewUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "ModelUpdateOrCreateOutput",
        "kind": "LinkedField",
        "name": "createOrUpdateModelV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Model",
            "kind": "LinkedField",
            "name": "model",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              (v11/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesChannel",
                "kind": "LinkedField",
                "name": "salesChannel",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EcommerceSettings",
                    "kind": "LinkedField",
                    "name": "ecommerceSettings",
                    "plural": false,
                    "selections": [
                      (v12/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductCode",
                "kind": "LinkedField",
                "name": "additionalCodes",
                "plural": true,
                "selections": [
                  (v8/*:: as any*/),
                  (v10/*:: as any*/),
                  (v13/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SalesChannel",
                    "kind": "LinkedField",
                    "name": "salesChannel",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EcommerceSettings",
                        "kind": "LinkedField",
                        "name": "ecommerceSettings",
                        "plural": false,
                        "selections": [
                          (v12/*:: as any*/),
                          (v14/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v16/*:: as any*/),
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v19/*:: as any*/),
              (v20/*:: as any*/),
              (v21/*:: as any*/),
              (v23/*:: as any*/),
              (v24/*:: as any*/),
              (v52/*:: as any*/),
              (v53/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "previewUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "ModelUpdateOrCreateOutput",
        "kind": "LinkedField",
        "name": "createOrUpdateModelV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Model",
            "kind": "LinkedField",
            "name": "model",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              (v11/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesChannel",
                "kind": "LinkedField",
                "name": "salesChannel",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EcommerceSettings",
                    "kind": "LinkedField",
                    "name": "ecommerceSettings",
                    "plural": false,
                    "selections": [
                      (v12/*:: as any*/),
                      (v3/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductCode",
                "kind": "LinkedField",
                "name": "additionalCodes",
                "plural": true,
                "selections": [
                  (v8/*:: as any*/),
                  (v10/*:: as any*/),
                  (v13/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SalesChannel",
                    "kind": "LinkedField",
                    "name": "salesChannel",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EcommerceSettings",
                        "kind": "LinkedField",
                        "name": "ecommerceSettings",
                        "plural": false,
                        "selections": [
                          (v12/*:: as any*/),
                          (v14/*:: as any*/),
                          (v3/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v16/*:: as any*/),
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v19/*:: as any*/),
              (v20/*:: as any*/),
              (v21/*:: as any*/),
              (v23/*:: as any*/),
              (v24/*:: as any*/),
              (v52/*:: as any*/),
              (v53/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "13ef0764f5e7eb07ca9758cfc829242b",
    "id": null,
    "metadata": {},
    "name": "previewUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation previewUpdateMutation(\n  $input: ModelUpdateOrCreateInput\n  $compressedInput: String\n) {\n  createOrUpdateModelV2(input: $input, compressedInput: $compressedInput) {\n    model {\n      id\n      modelID\n      statusID\n      configurationStatus\n      name\n      code\n      providerCode\n      salesChannelID\n      sourceProductTemplateID\n      salesChannel {\n        ecommerceSettings {\n          ecommerceName\n          id\n        }\n        id\n      }\n      additionalCodes {\n        code\n        salesChannelID\n        merchantProductName\n        salesChannel {\n          ecommerceSettings {\n            ecommerceName\n            remoteUrl\n            id\n          }\n          id\n        }\n      }\n      modelColorMappings {\n        colorID\n        merchantCode\n        salesChannelID\n      }\n      pricingModelID\n      largeImageUrl\n      smallImageUrl\n      provider\n      environment\n      options {\n        optionID\n        colorID\n        sideID\n        optionsData {\n          isResizable\n          is3DAutoGenEnabled\n          isSplitOutput\n          startWidth\n          minWidth\n          maxWidth\n          stepWidth\n          startHeight\n          minHeight\n          maxHeight\n          maxSizeForSide\n          stepHeight\n          minArea\n          maxArea\n          depth\n          keepAspectRatio\n          lockWidth\n          lockHeight\n          showWidthSize\n          showHeightSize\n          showSplitGrid\n          mirrorType\n          edgesColor\n          minSplitWidth\n          minSplitHeight\n          startSplitColumns\n          startSplitRows\n          includeBorderInPrintFiles\n          backgroundType\n          backgroundColor\n          backgroundPresetID\n          backgroundImageTempUrl\n          backgroundImageFileObjectID\n          backgroundImageThumbnailFileObjectID\n          backgroundImageUrl\n          backgroundImageThumbnailUrl\n          presets {\n            name\n            width\n            height\n          }\n          shape\n        }\n      }\n      sceneConfig {\n        general {\n          arEnabled\n          arAnchor\n        }\n      }\n      printTypes {\n        printTypeID\n        name\n        dpi\n        patID\n        outputTypeID\n        disableTextColors\n        disableImageColors\n        disableSellerImages\n        disableUserImages\n        useImagesFixedSize\n        canAddText\n        useCustomFonts\n        canChangeSvgColors\n        canUseImageFilters\n        canIgnoreDPIWarning\n        imageEditingToolSettingsToExclude\n        showImageProvider\n        canUseTextArt\n        defaultFontFamilyID\n        fonts {\n          fontFamilyID\n          fontFamilyName\n        }\n        textColors {\n          colorCode\n          isDefault\n        }\n        imageColors {\n          colorCode\n          isDefault\n        }\n        uploadRestrictions {\n          isUserImageAllowed\n          isJpgAllowed\n          isPngAllowed\n          isSvgAllowed\n          isPdfAllowed\n          isPdfWithRasterAllowed\n          isEpsAllowed\n          isFacebookAllowed\n          isInstagramAllowed\n        }\n        printTypeRestrictionsID\n        printTypeRestrictions {\n          disableTextColors\n          allowGradientTextColors\n          allowImageUploadTextColors\n          allowImageGalleryTextColors\n          enableVectorize\n          showVectorizeModal\n          vectorizeOption\n          createVectorizePreview\n          disableImageColors\n          disableSellerImages\n          disableUserImages\n          embeddedColorType\n          embeddedUseForRasterAlso\n          useImagesFixedSize\n          canAddText\n          useCustomFonts\n          canChangeSvgColors\n          canUseImageFilters\n          canIgnoreDPIWarning\n          canStretchImages\n          canStretchTexts\n          allowImageResizeUpload\n          minWidthImageResizeUpload\n          maxWidthImageResizeUpload\n          minHeightImageResizeUpload\n          maxHeightImageResizeUpload\n          allowImageResizeCliparts\n          minWidthImageResizeCliparts\n          maxWidthImageResizeCliparts\n          minHeightImageResizeCliparts\n          maxHeightImageResizeCliparts\n          imageEditingToolSettingsToExclude\n          imageInsertScalingUpload\n          imageInsertScalingCliparts\n          disableImageRotateUpload\n          disableImageRotateCliparts\n          showImageProvider\n          canUseTextArt\n          defaultFontFamilyID\n          convertPdfToSvg\n          convertAiToSvg\n          convertEpsToSvg\n          curvedText\n          allowBold\n          allowItalic\n          uppercase\n          maxNrTextElements\n          defaultColor\n          allowLeftAlign\n          allowCenterAlign\n          allowJustifyAlign\n          allowRightAlign\n          maxNrImages\n          textBox\n          allowLetterSpacing\n          minLetterSpacing\n          maxLetterSpacing\n          allowLineSpacing\n          minLineSpacing\n          maxLineSpacing\n          allowAdaptText\n          allowChangeFontSize\n          minFontSize\n          maxFontSize\n          fixedFontSize\n          fontSizeList\n          defaultFontSize\n          allowTopVerticalAlignment\n          allowMiddleVerticalAlignment\n          allowBottomVerticalAlignment\n          allowShadows\n          canPrintShadows\n          defaultShadowColor\n          defaultShadowBlur\n          defaultShadowDistance\n          defaultShadowAngle\n          minShadowBlur\n          maxShadowBlur\n          minShadowDistance\n          maxShadowDistance\n          minShadowAngle\n          maxShadowAngle\n          outputMirror\n          isLargeFileEnabled\n          allowTextStroke\n          minTextStrokeWidth\n          maxTextStrokeWidth\n          embeddedPdf\n          shadowColors {\n            colorCode\n            isDefault\n          }\n          fonts {\n            fontFamilyID\n            fontFamilyName\n          }\n          textColors {\n            colorCode\n            isDefault\n          }\n          imageColors {\n            colorCode\n            isDefault\n          }\n          uploadRestrictions {\n            isUserImageAllowed\n            isJpgAllowed\n            isPngAllowed\n            isSvgAllowed\n            isPdfAllowed\n            isPdfWithRasterAllowed\n            isEpsAllowed\n            isAiAllowed\n            isFacebookAllowed\n            isInstagramAllowed\n            resizeLargePdf\n          }\n        }\n      }\n      colors {\n        colorID\n        name\n        code\n        colorProviderCode\n        position\n        sides {\n          sideID\n          name\n          imageUrl\n          ppcm\n          code\n          sortOrder\n          mandatory\n          canRotate\n          cameraLocationID\n          areas {\n            areaID\n            boundsWidth\n            boundsHeight\n            boundsX\n            boundsY\n            path\n            pathSVG\n            name\n            clipOut\n            guid\n            layers {\n              layerID\n              name\n              displayName\n              description\n              isVisibleInCanvas\n              isVisibleInCart\n              isVisibleInOutput\n              showLabel\n              isClipMask\n              isOutputClipped\n              showIn3DPreview\n              displayOrder\n              svg\n              json\n            }\n            templateFile {\n              fileObjectID\n              documentWidth\n              documentHeight\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "60a067da5450cbd6c439e0c4ed9e8674";

export default node;
